import type { ProductionRun } from "./models";

export type EntryType = "PRODUCTION" | "WASTE" | "SCRAP";
const entryLabels: Record<EntryType, string> = {
  PRODUCTION: "Üretim",
  WASTE: "Iskarta",
  SCRAP: "Iskarta",
};
export const entryLabel = (type: ProductionRun["entries"][number]["type"]) =>
  type === "REWORK" ? "Iskarta" : entryLabels[type];
